import { ZfBox, ZfIcon, ZfTooltip } from '@zafire/react';

type FieldInfoTooltipProps = {
  fieldName: string;
  text: string;
};

export const FieldInfoTooltip = ({ fieldName, text }: FieldInfoTooltipProps) => (
  <ZfBox slot="trailing" styles={{ display: 'flex' }}>
    <ZfIcon name="info" id={`${fieldName}-anchor`} aria-describedby={`${fieldName}-tooltip`} size="large" />
    <ZfTooltip
      id={`${fieldName}-tooltip`}
      anchor={`${fieldName}-anchor`}
      side="top"
      alignment="start"
      text={text}
      content-alignment=""
    ></ZfTooltip>
  </ZfBox>
);
